// @ts-strict-ignore
import capitalize from 'lodash/capitalize';
import { getInputAttributeDataTypes } from 'flow/service/actions';
import type { DataType, DataTypeOption, FormState } from './types';
import type { NodeEditorFormAdapter } from '../../useNodeEditorForm';
import { parseBooleanString } from '~/dashboard/views/workflows/service/util';


function buildDataTypeOption(dataType: DataType): DataTypeOption {
  return {
    label: capitalize(dataType),
    value: dataType,
  };
}
export function getDataTypeOptions(): DataTypeOption[] {
  const dataTypes = getInputAttributeDataTypes();
  return dataTypes.map(buildDataTypeOption);
}


export const inputAttributeConfigurationFormAdapter: NodeEditorFormAdapter<FormState> = {
  getDefaultFormValues(action, workflowProps) {
    const { input } = action;
    const publishedAttribute = workflowProps.publishedAttributes
      .find(pa => pa.attributeToken === input.publishedAttributeToken);

    // build the form objet prioritizing published attribute data if it exists
    return {
      attributeName: publishedAttribute?.attributeName ?? input.name,
      attributeToken: publishedAttribute?.attributeToken ?? input.publishedAttributeToken,
      containsPii: publishedAttribute?.containsPii,
      dataType: buildDataTypeOption(publishedAttribute?.dataType ?? input.dataType as DataType),
      defaultValue: publishedAttribute?.defaultValue,
      defaultValueNote: publishedAttribute?.defaultValueNote,
      hasExpiration: publishedAttribute?.hasExpiration,
      // Input Action to form -> convert from boolean string to pure boolean
      hasJqFilter: publishedAttribute?.hasJqFilter ?? parseBooleanString(input.useJq),
      jqFilter: publishedAttribute?.jqFilter ?? input.jqFunction,
      valueExpiresInDays: publishedAttribute?.valueExpiresInDays,
      validValueMin: publishedAttribute?.validValueMin,
      validValueMax: publishedAttribute?.validValueMax,
      validValues: publishedAttribute?.validValues,
      agentCanCreateValue: publishedAttribute?.agentCanCreateValue,
      groupingToken: publishedAttribute?.groupingToken,
    };
  },
  // this maps form data **specific to the input action**
  // published attribute form data is mapped separately
  mapFormDataToAction(data, sourceAction) {
    return {
      ...sourceAction,
      input: {
        ...sourceAction.input,
        dataType: data.dataType.value,
        jqFunction: data.jqFilter ?? '',
        name: data.attributeName,
        // form to Input Action -> convert boolean into boolean string
        useJq: String(data.hasJqFilter),
        publishedAttributeToken: data.attributeToken || null,
      },
    };
  },
};
